import axios from 'axios';
import moment from 'moment';

import { API_HOST } from '../../constans/api';

export const SWITCH_NEAR_TICKETS_POPUP = 'SWITCH_NEAR_TICKETS_POPUP';
export const REQUEST_NEAR_TICKETS = 'REQUEST_NEAR_TICKETS';
export const RESPONSE_NEAR_TICKETS = 'RESPONSE_NEAR_TICKETS';

export const switchNearTicketsPopupAction = () => (dispatch) => {
    dispatch({ type: SWITCH_NEAR_TICKETS_POPUP });
};

export const getNearTicketsAction = speciality => (dispatch) => {
    dispatch({ type: REQUEST_NEAR_TICKETS });

    axios.get(`${API_HOST}tickets/nearest?services=${speciality}&token=${window.vpriemScheduleParams.token}`)
    .then((response) => {
        if (!response.data.error) {
            dispatch({ type: RESPONSE_NEAR_TICKETS, payload: response.data.data });
        } else {
            dispatch({ type: RESPONSE_NEAR_TICKETS, payload: null });
        }
    })
    .catch((error) => {
        dispatch({ type: RESPONSE_NEAR_TICKETS, payload: null });
        console.error(error);
    });
};
